<template>
  <div class="body-class">
    <div class="gradient-bg flex-mid">
      <div class="chart-bg">
        <div class="font-header">
          65% of recognition is tagged with your core #values
        </div>
        <div class="font-description">Overall participation rate: 84%</div>
        <div class="chart-container">
          <div v-for="data in chartData" :key="data.id" class="chart-bar">
            <div class="bar-value center">{{ data.grayValue }}</div>
            <div
              class="bar"
              :style="`height: ${
                heightGrayBar(data.grayMaxValue, data.grayValue) >
                heightMainBar(data.recongnitionMaxValue, data.recongnitionValue)
                  ? heightGrayBar(data.grayMaxValue, data.grayValue)
                  : heightMainBar(
                      data.recongnitionMaxValue,
                      data.recongnitionValue
                    )
              }px;`"
            >
              <div
                class="bg-bar"
                :style="`height: ${heightGrayBar(
                  data.grayMaxValue,
                  data.grayValue
                )}px;`"
              ></div>
              <div
                class="main-bar"
                :style="`height: ${heightMainBar(
                  data.recongnitionMaxValue,
                  data.recongnitionValue
                )}px;`"
              >
                <div
                  class="main-label"
                  :style="`height: ${heightMainBar(
                    data.recongnitionMaxValue,
                    data.recongnitionValue
                  )}px;`"
                >
                  {{ data.recongnitionValue }}%
                </div>
              </div>
            </div>
            <div class="line"></div>
            <div class="label center">{{ data.label }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
    
<script>
export default {
  name: "recognition-with-core-values",
  data() {
    return {
      chartData: [
        {
          id: "test-od2n1esas",
          grayMaxValue: 400,
          grayValue: 241,
          recongnitionMaxValue: 100,
          recongnitionValue: 30,
          label: "JUL",
        },
        {
          id: "test-o24n221e",
          grayMaxValue: 400,
          grayValue: 400,
          recongnitionMaxValue: 100,
          recongnitionValue: 58,
          label: "AUG",
        },
        {
          id: "test-o2n1e31",
          grayMaxValue: 400,
          grayValue: 372,
          recongnitionMaxValue: 100,
          recongnitionValue: 65,
          label: "SEP",
        },
      ],
    };
  },
  methods: {
    heightGrayBar(max, value) {
      // max heigth: 150px;
      const maxPixel = 150;
      const percentage = (value / max) * 100;
      const height = (percentage / 100) * maxPixel;
      return height || "0";
    },
    heightMainBar(max, value) {
      // max heigth: 150px;
      const maxPixel = 150;
      const percentage = (value / max) * 100;
      const height = (percentage / 100) * maxPixel;
      return height || "0";
    },
  },
};
</script>
  
<style lang="scss" scoped>
$zomeSize: 2;
.body-class {
  background-color: #fff;
}
.gradient-bg {
  background: transparent linear-gradient(119deg, #0caca5 0%, #6d27bf 100%) 0%
    0% no-repeat padding-box;
  width: calc(428px * #{$zomeSize});
  height: calc(260px * #{$zomeSize});
  border-radius: calc(4px * #{$zomeSize});
}

.font-header {
  font-size: calc(13px * #{$zomeSize});
  font-weight: 900;
}
.font-description {
  font-size: calc(11px * #{$zomeSize});
  font-weight: 700;
  opacity: 0.4;
}

.chart-bg {
  $chart-bg-ppadding: 20px;
  background-color: #fff;
  padding: calc(#{$chart-bg-ppadding * $zomeSize});
  width: calc((360px - #{$chart-bg-ppadding * $zomeSize}) * #{$zomeSize});
  height: calc((192px - #{$chart-bg-ppadding * $zomeSize}) * #{$zomeSize});
  border-radius: calc(4px * #{$zomeSize});
}

.chart-container {
  display: flex;
  height: 250px;
  align-items: flex-end;
  justify-content: space-around;
  padding: 0 calc(20px * #{$zomeSize});
  .chart-bar {
    position: relative;
    width: 100%;
    .bar-value {
      color: rgba($color: #000000, $alpha: 0.6);
      font-size: calc(11px * #{$zomeSize});
    }
    .bar {
      $barWidth: 40px;
      position: relative;
      .bg-bar {
        position: absolute;
        left: calc(50% - #{$barWidth});
        bottom: 0;
        background-color: #c7c7c7;
        border-radius: calc(6px * #{$zomeSize});
        width: calc(#{$barWidth * $zomeSize});
      }
      .main-bar {
        position: absolute;
        left: calc(50% - #{$barWidth});
        bottom: 0;
        background-color: #6d27bf;
        border-radius: calc(6px * #{$zomeSize});
        width: calc(#{$barWidth * $zomeSize});
        .main-label {
          font-size: calc(13px * #{$zomeSize});
          padding-left: calc(#{$barWidth * $zomeSize} + 8px);
          width: calc(#{$barWidth * $zomeSize});
          font-weight: 700;
          color: #6d27bf;
          display: flex;
          align-content: center;
          align-items: center;
        }
      }
    }
    .line {
      width: 100%;
      height: calc(1px * #{$zomeSize});
      background-color: rgba($color: #000000, $alpha: 0.1);
      margin-top: calc(4px * #{$zomeSize});
    }
    .label {
      font-size: calc(11px * #{$zomeSize});
      font-weight: 700;
      color: rgba($color: #000000, $alpha: 0.8);
      margin-top: calc(6px * #{$zomeSize});
    }
  }
}
</style>
    